module.exports = __webpack_public_path__ + "static/media/r7.d44476af.jpg";